import { getAnchorName } from '@shared/styles';

/** The card update modal's CSS anchor, for surfaces positioned against its edges. */
export const CARD_UPDATE_MODAL_ANCHOR_NAME = getAnchorName('card-update-modal');
